/**
 * 鉤子
 * 授權
 * @author J
 * @since 2024-04-30 07:34:25
 */

import {computed} from "vue"
import {AuthStore} from "@/store/modules/auth";

/**
 * 實例
 */
export const useAuthorization = () => {

    const authStore = AuthStore()

    /**
     * 是否 - 登入
     */
    const isLogin = computed(() => authStore.isLogin)

    /**
     * 登入 / 登出（權杖在 httpOnly cookie，由後端設定與清除）
     */
    const setLogin = (login) => authStore.setLogin(login)

    return {
        isLogin,
        setLogin
    }

}
